import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Star, Quote } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Stars = ({ count, className = 'h-4 w-4' }) => (
  <div className="flex gap-0.5" aria-label={`${count} de 5 estrellas`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`${className} ${i <= count ? 'fill-amber-400 text-amber-400' : 'text-slate-300'}`} />
    ))}
  </div>
);

export const Testimonials = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then(({ data }) => setItems(data.data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="py-20 bg-white relative overflow-hidden" data-testid="testimonials-section">
      <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-blue-100 blur-3xl opacity-70"></div>
      <div className="absolute -bottom-24 -left-24 w-80 h-80 rounded-full bg-red-100 blur-3xl opacity-60"></div>
      <div className="container mx-auto px-4 relative">
        <div className="max-w-2xl mb-14">
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-blue-600 bg-blue-50 rounded-full px-4 py-1.5 mb-4">
            <Star className="h-4 w-4 fill-blue-600" /> Opiniones reales
          </span>
          <h3 className="text-4xl font-bold text-slate-900 mb-3">Lo que dicen nuestros clientes</h3>
          <p className="text-lg text-slate-600">Personas que ya viajan y viven protegidas con IwannaInsurance.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {items.map((t, i) => (
            <figure
              key={t.id}
              data-testid={`testimonial-card-${i}`}
              className="relative bg-slate-50 border border-slate-100 rounded-3xl p-7 flex flex-col hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300"
              style={{ animationDelay: `${i * 120}ms` }}
            >
              <Quote className="absolute top-6 right-6 h-8 w-8 text-blue-200" />
              <Stars count={t.estrellas} />
              <blockquote className="mt-4 text-slate-700 leading-relaxed flex-1">“{t.texto}”</blockquote>
              <figcaption className="mt-6 flex items-center gap-4">
                {t.foto_url ? (
                  <img src={t.foto_url} alt={t.nombre} className="h-14 w-14 rounded-full object-cover ring-4 ring-white shadow-md" loading="lazy" />
                ) : (
                  <div className="h-14 w-14 rounded-full bg-gradient-to-br from-blue-600 to-red-500 text-white flex items-center justify-center font-bold text-lg ring-4 ring-white shadow-md">
                    {t.nombre.charAt(0)}
                  </div>
                )}
                <div>
                  <p className="font-semibold text-slate-900">{t.nombre}</p>
                  {t.ciudad && <p className="text-sm text-slate-500">{t.ciudad}</p>}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
